import { Link } from './link'
import { Logo } from './logo'
import { PlusGrid, PlusGridItem, PlusGridRow } from './plus-grid'

export function Navbar({ banner }) {
  return (
    <header className="pt-12 sm:pt-16">
      <PlusGrid>
        <PlusGridRow className="relative flex justify-start">
          <PlusGridItem className="py-3">
            <Link href="/" title="Home">
              <Logo className="h-9" />
            </Link>
          </PlusGridItem>
        </PlusGridRow>
      </PlusGrid>
    </header>
  )
}
